var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"pt-0"},[_c('v-row',[_c('v-col',[_c('span',{staticClass:"headline pb-1"},[_vm._v(_vm._s(_vm.$t('playerProfileDialog.title')))])])],1),(_vm.user)?_c('v-row',[_c('v-col',[_c('player-profile-content',{attrs:{"user":_vm.user}})],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }